/**
 * V12 数据中心 — 数据模块注册表
 *
 * 定义所有业务模块的元数据：作用域、存储类型、版本号。
 * 新增数据模块时在此文件中添加。
 *
 * @see design/v12-user-data-center/spec.md §FR-001
 */

// ============================================================
// 数据模块列表
// ============================================================

export const DATA_MODULES = [
  "demo-projects",
  "works",
  "v5-progress",
  "demo-stats",
  "git-history",
  "sharpen-v3",
  "arena-state",
  "arena-history",
  "evals-history",
  "showcase-baseline",
  "battle-history",
  "forge-progress",
] as const;

export type DataModule = (typeof DATA_MODULES)[number];

// ============================================================
// 模块元数据
// ============================================================

export interface ModuleMeta {
  name: DataModule;
  /** user = 跟随 openid，device = 跟随设备 */
  scope: "user" | "device";
  /** 当前只支持 localStorage */
  storage: "localStorage";
  /** 数据格式版本（用于未来迁移） */
  version: number;
  /** 最大字节（P1 服务端限制用） */
  maxSize?: number;
}

export const MODULE_REGISTRY: Record<DataModule, ModuleMeta> = {
  "demo-projects": {
    name: "demo-projects",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  works: {
    name: "works",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "v5-progress": {
    name: "v5-progress",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "demo-stats": {
    name: "demo-stats",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "git-history": {
    name: "git-history",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "sharpen-v3": {
    name: "sharpen-v3",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "arena-state": {
    name: "arena-state",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "arena-history": {
    name: "arena-history",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "evals-history": {
    name: "evals-history",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "showcase-baseline": {
    name: "showcase-baseline",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "forge-progress": {
    name: "forge-progress",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
  "battle-history": {
    name: "battle-history",
    scope: "user",
    storage: "localStorage",
    version: 1,
  },
};

// ============================================================
// 设备级 key（不走 DataProxy 的用户数据 API，直接读 localStorage）
// ============================================================

export const DEVICE_KEYS = [
  "battlecode-llm-api-key",
  "battlecode-llm-daily-count",
  "battlecode-llm-daily-date",
  "battlecode-editor",
  "battlecode-theme",
  "battlecode-locale",
  "battlecode-device-id",
] as const;

// ============================================================
// 旧 key → 新模块名映射（用于迁移检测）
// ============================================================

export const LEGACY_KEY_MAP: Record<string, DataModule> = {
  "battlecode-demo-projects": "demo-projects",
  "battlecode-works": "works",
  "battlecode-v5-progress": "v5-progress",
  "battlecode-demo-stats": "demo-stats",
  "battlecode-git-history": "git-history",
  "battlecode-sharpen-v3": "sharpen-v3",
  "battlecode-arena-state": "arena-state",
  "battlecode-arena-history": "arena-history",
  "battlecode-evals-history": "evals-history",
  "battlecode-showcase-baseline": "showcase-baseline",
};
